import { DamageIssueType, ItemCondition, ItemType, PackageType, PackageTypeCondition } from '../../../../enums';

export interface IProductDamageSubtypeInt {
    issueType: DamageIssueType;
    itemType: ItemType;
    conditionOfItem: ItemCondition[];
    carrierTrackingNumber?: string;
    documentationNotedIssue?: boolean;
    explanationOfMissingNote?: string;
    damageClaimFiled?: boolean;
    packageType?: PackageType;
    protectivePackagingUsed?: boolean;
    packageTypeCondition?: PackageTypeCondition;
    additionalPackagingInfo?: string;
    canIdentifyCartonId?: boolean;
    cartonId?: string;
}
